var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6871 3.56833L2.42755 19.8121C2.22672 20.0129 1.98366 20.1106 1.69839 20.105C1.41311 20.0997 1.17005 19.9967 0.969219 19.7958C0.768385 19.595 0.667969 19.3568 0.667969 19.0813C0.667969 18.8057 0.768385 18.5632 0.969219 18.3538L17.213 2.09417H2.6613C2.36464 2.09417 2.11602 1.99319 1.91547 1.79125C1.71491 1.58958 1.61464 1.33958 1.61464 1.04125C1.61464 0.743194 1.71491 0.495139 1.91547 0.297084C2.11602 0.099028 2.36464 0 2.6613 0H19.4776C19.847 0 20.1566 0.124861 20.4063 0.374583C20.656 0.624583 20.7809 0.934168 20.7809 1.30333V18.1196C20.7809 18.4163 20.6801 18.665 20.4784 18.8658C20.2767 19.0664 20.0267 19.1667 19.7284 19.1667C19.4301 19.1667 19.182 19.0664 18.9842 18.8658C18.7862 18.665 18.6871 18.4163 18.6871 18.1196V3.56833Z",
    fill: "#D2E4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRight);
export default __webpack_public_path__ + "static/media/top-right.7d85532b9c4812797e997043b774a1e0.svg";
export { ForwardRef as ReactComponent };